export default __webpack_public_path__ + "static/media/42_mobile.d0051d63.jpg";